var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
(() => {
    angular.module('QMC.Medikamente', []).config(routes);
    // Medikamente
    routes.$inject = ['$locationProvider', '$stateProvider', '$urlRouterProvider', 'qmcBase'];
    function routes($locationProvider, $stateProvider, $urlRouterProvider, qmcBase) {
        $locationProvider.html5Mode({
            enabled: false,
            requireBase: false
        });
        $stateProvider
            .state('medicament', {
            url: '/medicament',
            templateUrl: qmcBase + '/Medikamente',
            controller: 'MedikamenteListController',
            controllerAs: 'vm',
            resolve: {
                data: [() => {
                        console.log('Current State: Medicament');
                    }]
            }
        }).state('medicamentList', {
            url: '/medicament/List',
            templateUrl: qmcBase + '/Medikamente/List',
            controller: 'MedikamenteListController',
            controllerAs: 'vm',
            resolve: {
                data: [() => {
                        console.log('Current State: Medicament list');
                    }]
            }
        }).state('medicamentDetail', {
            url: '/medicament/:id',
            templateUrl: qmcBase + '/Medikamente/Detail',
            controller: 'MedikamenteDetailController',
            controllerAs: 'vm',
            resolve: {
                data: [() => {
                        console.log('Current State: Medicament detail');
                    }]
            }
        }).state('medicamentPlannedDistribution', {
            url: '/medicament/plannedDistribution',
            templateUrl: qmcBase + '/Medikamente/PlannedDistribution',
            controller: 'MedikamenteDistributionController',
            controllerAs: 'vm',
            resolve: {
                data: [() => {
                        console.log('Current State: Medicament distributed');
                    }]
            }
        }).state('medicamentDemandDistribution', {
            url: '/medicament/demandDistribution',
            templateUrl: qmcBase + '/Medikamente/DemandDistribution',
            controller: 'MedikamenteDistributionController',
            controllerAs: 'vm',
            resolve: {
                data: [() => {
                        console.log('Current State: Medicament distributed');
                    }]
            }
        })
            .state('medicamentDistributionReference', {
            url: '/medicament/distribution/:reference',
            templateUrl: qmcBase + '/Medikamente/Distribution',
            controller: 'MedikamenteDistributionController',
            controllerAs: 'vm',
            resolve: {
                data: [() => {
                        console.log('Current State: Medicament distributed Reference');
                    }]
            }
        });
    }
})();
var QMC;
(function (QMC) {
    var Medikamente;
    (function (Medikamente) {
        class HttpProvider {
            static configureHttpProvider($httpProvider) {
                // initialize get if not there
                if (!$httpProvider.defaults.headers.get) {
                    $httpProvider.defaults.headers.get = {};
                }
                // disable IE ajax request caching
                $httpProvider.defaults.headers.get['If-Modified-Since'] = 'Mon, 26 Jul 1997 05:00:00 GMT';
                // extra
                $httpProvider.defaults.headers.get['Cache-Control'] = 'no-cache';
                $httpProvider.defaults.headers.get['Pragma'] = 'no-cache';
            }
        }
        Medikamente.HttpProvider = HttpProvider;
    })(Medikamente = QMC.Medikamente || (QMC.Medikamente = {}));
})(QMC || (QMC = {}));
(() => {
    angular.module('QMC.Medikamente')
        .config(['$httpProvider', QMC.Medikamente.HttpProvider.configureHttpProvider]);
})();
var QMC;
(function (QMC) {
    var Medikamente;
    (function (Medikamente) {
        let MedikamenteService = class MedikamenteService extends QMC.Common.BaseService {
            constructor($http, $q) {
                super($http, $q);
                this.$http = $http;
                this.$q = $q;
                this.modulePath = '/Medicament';
            }
            //////////////////////////// Medicament //////////////////////////
            getMedicamentWv() {
                return super.getItem(this.modulePath + '/WvModel', {}, (data) => {
                    return data;
                });
            }
            getMedicament(id) {
                return super.getItem(this.modulePath + '/' + id, {}, (data) => {
                    return data;
                });
            }
            getMedicamentList(page, pageSize, listSearch = '', searchProperties = [], sortBy = '', sortDescending = false) {
                return super.getItem(this.modulePath + '', { page: page, pageSize: pageSize, listSearch: listSearch, searchProperties, sortBy, sortDecending: sortDescending }, (data) => {
                    return data;
                });
            }
            postMedicament(data) {
                return super.post(this.modulePath + '', data).then((data) => {
                    return data;
                });
            }
            putMedicament(id, data) {
                return super.put(this.modulePath + '/' + id, data).then((data) => {
                    return data;
                });
            }
            deleteMedicament(id) {
                return super.delete(this.modulePath + '/' + id).then((data) => {
                    return data;
                });
            }
            //////////////////////// Medicament Package //////////////////////
            getMedicamentPackageWv() {
                return super.getItem(this.modulePath + '/Package/WvModel', {}, (data) => {
                    return data;
                });
            }
            postMedicamentPackage(data) {
                return super.post(this.modulePath + '/Package', data).then((data) => {
                    return data;
                });
            }
            putMedicamentPackage(id, data) {
                return super.put(this.modulePath + '/Package/' + id, data).then((data) => {
                    return data;
                });
            }
            getMedicamentPackage(id, parentId) {
                return super.getItem(this.modulePath + '/Package/' + id + "/" + parentId, {}, (data) => {
                    return data;
                });
            }
            deleteMedicamentPackage(id, parentId) {
                return super.delete(this.modulePath + '/Package/' + id + '/' + parentId).then((data) => {
                    return data;
                });
            }
            getMedicamentPackageList(id) {
                return super.get(this.modulePath + '/Package/' + id, {}, (data) => {
                    return data;
                });
            }
            /////////////////////////// Distribution /////////////////////////
            getMedicationLists(dateFrom, dateTo, onlyUncompleted, onlyUndocumented) {
                return super.getItem(this.modulePath + '/Medication', { dateFrom: dateFrom, dateTo: dateTo, onlyUncompleted: onlyUncompleted, onlyUndocumented: onlyUndocumented }, (data) => {
                    return data;
                });
            }
            getDemandMedicationLists(dateFrom, dateTo, onlyUncompleted, onlyUndocumented) {
                return super.get(this.modulePath + '/Medication/Demand', { dateFrom: dateFrom, dateTo: dateTo, onlyUncompleted: onlyUncompleted, onlyUndocumented: onlyUndocumented }, (data) => {
                    return data;
                });
            }
            getPlannedMedicationLists(dateFrom, dateTo, onlyUncompleted, onlyUndocumented) {
                return super.get(this.modulePath + '/Medication/Planned', {
                    dateFrom: dateFrom, dateTo: dateTo, onlyUncompleted: onlyUncompleted, onlyUndocumented: onlyUndocumented
                }, (data) => {
                    return data;
                });
            }
            getDistributionsForMedication(dateFrom, dateTo, medicationId) {
                return super.get(this.modulePath + '/Medication/DistributionsForMedication', { dateFrom: dateFrom, dateTo: dateTo, medicationId: medicationId }, (data) => {
                    return data;
                });
            }
            getMedicationWv() {
                return super.getItem(this.modulePath + '/Medication/WvModel', {}, (data) => {
                    return data;
                });
            }
            postMedication(reference, data) {
                return super.post(this.modulePath + '/Medication/' + reference, data).then((data) => {
                    return data;
                });
            }
            postMedications(data) {
                return super.post(this.modulePath + '/Medication/', data).then((data) => {
                    return data;
                });
            }
            postValidation(data) {
                return super.post(this.modulePath + '/Medication/WarningsAndErrors', data).then((data) => {
                    return data;
                });
            }
        };
        MedikamenteService = __decorate([
            QMC.Service('QMC.Medikamente', 'MedikamenteService'),
            QMC.Inject('$http', '$q')
        ], MedikamenteService);
        Medikamente.MedikamenteService = MedikamenteService;
    })(Medikamente = QMC.Medikamente || (QMC.Medikamente = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Medikamente;
    (function (Medikamente) {
        let MedikamenteListController = class MedikamenteListController {
            constructor($location, medicamentService, $qui, $stateParams, $state, $scope, lng, permissionService, userService) {
                this.$location = $location;
                this.medicamentService = medicamentService;
                this.$qui = $qui;
                this.$state = $state;
                this.$scope = $scope;
                this.lng = lng;
                this.permissionService = permissionService;
                this.userService = userService;
                //////////////////////////// Variables ///////////////////////////
                /************************* GUI Variables ************************/
                this.ui = new Medikamente.UserInterface();
                this.allowTableExport = false;
                this.page = 0;
                this.filter = '';
                this.sortBy = '';
                this.sortDescending = false;
                this.modify = true;
                this.onSort = (sortBy, sortDescending) => {
                    this.sortBy = sortBy;
                    this.sortDescending = sortDescending;
                    this.page = 0;
                    this.getData();
                };
                $qui.init($qui.getSectionColor($location.path()), () => {
                    $qui.anonAvatar();
                    $qui.bindEvents();
                    $(".help-block").parent("div").attr("style", "");
                });
                if (document.getElementById("permissions").getAttribute("medicament").toLocaleLowerCase() !== "true") {
                    console.log("No rights to see module medicament");
                    this.forbidden = true;
                    return;
                }
                this.cards = QMC.Common.Constants.IS_MOBILE;
                this.$qui.getTableAutoload(this.userService).then((ltd) => {
                    this.shouldLoadTableData = ltd;
                    if (this.shouldLoadTableData) {
                        this.$scope.$watch('vm.filter', function (newValue, oldValue) {
                            if (newValue === oldValue)
                                return;
                            const lastValue = this.filter;
                            setTimeout(() => {
                                if (this.filter === lastValue) {
                                    this.getData();
                                }
                            }, 500);
                        }.bind(this, this));
                    }
                });
                this.getWvs();
                this.init();
                this.permissionLoad = true;
                permissionService.getPermissionsByObjectType(810000).then((data) => {
                    this.delete = data[0].delete;
                    this.new = data[0].new;
                    this.modify = data[0].modify;
                    this.view = data[0].view;
                    this.allowTableExport = data[0].print;
                    this.permissionLoad = false;
                });
            }
            ////////////////////////// DISPLAYLOGIC //////////////////////////
            init() {
                this.formState = "new";
                this.form = {
                    id: null,
                    objectId: null,
                    title: null,
                    presentationId: null,
                    producerId: null,
                    categoryId: null,
                    isPrescriptionNeeded: false,
                    isPharmacyOnly: false,
                    isRestricted: false,
                    isAnesthetic: false,
                    activeComponent: null,
                    comment: null,
                    mediNr: null
                };
            }
            setPage(page) {
                this.page = page;
            }
            getData() {
                if (this.pageWatcher)
                    this.pageWatcher();
                this.getMedicaments();
                this.page = 0;
            }
            ////////////////////////// SERVICECALLS //////////////////////////
            getMedicaments() {
                this.medicamentLoad = true;
                if (this.pageWatcher)
                    this.pageWatcher();
                this.medicamentService.getMedicamentList(this.page, QMC.Common.Constants.DEFAULT_PAGINATION_SIZE, this.filter, this.ui.getDisplayedPropertiesFromSchema(this.ui.medicamentTable), this.sortBy, this.sortDescending).then((data) => {
                    this.medicaments = data.items;
                    this.paginationInfo = data.paginationInfo;
                    this.ui.medicamentTable.data = data.items;
                    this.$qui.functionWaiter("ui.createTable", this);
                    this.medicamentLoad = false;
                    this.pageWatcher = this.$scope.$watch('vm.page', (newValue, oldValue) => {
                        if (newValue !== oldValue)
                            this.getMedicaments();
                    });
                });
            }
            addMedicament() {
                if (this.form.title !== null && this.form.title !== undefined && this.form && this.form.presentationId !== null && this.form.presentationId !== undefined) {
                    this.medicamentService.postMedicament(this.form).then(() => {
                        this.ui.notify(this.ui.successNote);
                        $('body').removeClass('modal-open');
                        $('.modal-backdrop').remove();
                        this.formState = "new";
                        this.getData();
                    });
                }
            }
            getPresentationWvList() {
                return this.ui.select(this.wvLists.presentationWvList, { value: "objectId", text: "name" });
            }
            getCategoryList() {
                return this.ui.select(this.wvLists.categoryWvList, { value: "objectId", text: "name" });
            }
            getProducerWvList() {
                return this.ui.select(this.wvLists.producerWvList, { value: "objectId", text: "name" });
            }
            getWvs() {
                this.medicamentLoad = true;
                this.medicamentService.getMedicamentWv().then((data) => {
                    this.wvLists = data;
                    this.$qui.functionWaiter("ui.createForm", this);
                    this.medicamentLoad = false;
                });
            }
        };
        MedikamenteListController = __decorate([
            QMC.Controller('QMC.Medikamente', 'MedikamenteListController'),
            QMC.Inject('$location', 'MedikamenteService', '$qui', '$stateParams', '$state', '$scope', 'QmcLanguageService', 'QmcPermissionService', 'UserService')
        ], MedikamenteListController);
    })(Medikamente = QMC.Medikamente || (QMC.Medikamente = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Medikamente;
    (function (Medikamente) {
        let MedikamenteDetailController = class MedikamenteDetailController {
            /**
             * Creates an instance of MedikamenteDetailController.
             * @param {MedikamenteService} medicamentService
             * @param {any} $qui
             * @param {any} $stateParams
             * @param {any} $state
             * @param {any} $scope
             * @param {Common.QmcLanguageService} lng
             * @param {Common.QmcPermissionService} permissionService
             *
             * @memberOf MedikamenteDetailController
             */
            constructor($location, medicamentService, $qui, $stateParams, $state, $scope, lng, permissionService) {
                this.$location = $location;
                this.medicamentService = medicamentService;
                this.$qui = $qui;
                this.$state = $state;
                this.$scope = $scope;
                this.lng = lng;
                this.permissionService = permissionService;
                //////////////////////////// Variables ///////////////////////////
                /************************* GUI Variables ************************/
                this.ui = new Medikamente.UserInterface();
                $qui.init($qui.getSectionColor("/medicament"), () => {
                    $qui.anonAvatar();
                    $qui.bindEvents();
                });
                if (document.getElementById("permissions").getAttribute("medicament").toLocaleLowerCase() !== "true") {
                    console.log("No rights to see module medicament");
                    this.forbidden = true;
                    return;
                }
                this.medicamentId = $stateParams.id;
                this.init();
                this.initPackageForm();
                this.getMedicament($stateParams.id);
                this.getWvs();
                $scope.$on('$locationChangeStart', event => {
                    if ($scope.vm.medicationForm.$dirty) {
                        // show warning, if answer negative stay on this side
                        if (!confirm(this.lng.translate(20000039, 'Wenn Sie diese Seite verlassen gehen alle Änderungen verloren. Fortfahren?'))) {
                            event.preventDefault();
                        }
                    }
                });
                this.lang = lng;
                this.promptOptions = {
                    title: "Medikament",
                    yesNo: true,
                    icon: "qm-icon-history2",
                    text: this.lang.translate(20000290, 'Wollen Sie den Eintrag wirklich löschen?')
                };
                this.permissionLoad = true;
                permissionService.getPermissionsByObjectTypes([810000, 810003]).then((data) => {
                    this.delete = data[0].delete && data[0].moduleAccess;
                    this.new = data[0].new && data[0].moduleAccess;
                    this.modify = data[0].modify && data[0].moduleAccess;
                    this.view = data[0].view && data[0].moduleAccess;
                    this.pdelete = data[1].delete && data[1].moduleAccess;
                    this.pnew = data[1].new && data[1].moduleAccess;
                    this.pmodify = data[1].modify && data[1].moduleAccess;
                    this.pview = data[1].view && data[1].moduleAccess;
                    this.permissionLoad = false;
                    this.getMedicamentPackages(this.medicamentId);
                });
            }
            ////////////////////////// DISPLAYLOGIC //////////////////////////
            /**
             * init mediactionform
             *
             * @private
             *
             * @memberOf MedikamenteDetailController
             */
            init() {
                this.medicationForm = {
                    id: null,
                    objectId: null,
                    title: null,
                    application: null,
                    sideEffect: null,
                    contraindication: null,
                    interaction: null,
                    presentationId: null,
                    producerId: null,
                    categoryId: null,
                    isPrescriptionNeeded: false,
                    isPharmacyOnly: false,
                    isRestricted: false,
                    isAnesthetic: false,
                    activeComponent: null,
                    comment: null,
                    restriction: null,
                    mediNr: null,
                    producer: null,
                    packageTypes: []
                };
                this.filter = {
                    'searchText': ""
                };
            }
            /**
             * init Packageform
             *
             * @private
             *
             * @memberOf MedikamenteDetailController
             */
            initPackageForm() {
                this.formState = "new";
                this.packageForm = {
                    id: null,
                    objectId: null,
                    parentId: this.medicamentId,
                    dateFrom: new Date(),
                    dateTo: null,
                    packageAmount: 0,
                    packageUnitId: null,
                    standardSizeId: null,
                    pzn: null,
                    ean: null,
                    activeComponentAmount: null,
                    activeComponentUnitId: null,
                    comment: null
                };
            }
            /**
             * check if param is correct guid
             *
             * @private
             * @param {Guid} thing
             * @returns {boolean}
             *
             * @memberOf MedikamenteDetailController
             */
            isSetGuid(thing) {
                if (thing !== null && thing !== undefined && thing !== QMC.Common.Constants.GUID_EMPTY)
                    return true;
                else
                    return false;
            }
            ////////////////////////// SERVICECALLS //////////////////////////
            /**
             * get Medication from API
             *
             * @private
             * @param {Guid} id
             *
             * @memberOf MedikamenteDetailController
             */
            getMedicament(id) {
                this.medicamentLoad = true;
                this.medicamentService.getMedicament(id).then((data) => {
                    this.medicationForm = angular.copy(data);
                    this.storedData = angular.copy(data);
                    this.displayTitle = data.title;
                    this.medicamentLoad = false;
                });
            }
            /**
             * get all Packages for Medication
             *
             * @private
             * @param {Guid} id
             *
             * @memberOf MedikamenteDetailController
             */
            getMedicamentPackages(id) {
                this.packageLoad = true;
                this.medicamentService.getMedicamentPackageList(id).then((data) => {
                    this.medicationForm = angular.copy(this.storedData);
                    this.ui.mediPackagesTable.data = data;
                    this.$qui.functionWaiter("ui.createTable", this);
                    this.packageLoad = false;
                });
            }
            /**
             * put modified mediaction to API
             *
             * @private
             *
             * @memberOf MedikamenteDetailController
             */
            putMedicament() {
                this.medicamentService.putMedicament(this.medicationForm.objectId, this.medicationForm).then((data) => {
                    this.$qui.notify(this.$qui.successNote, this.lng.translate(20000291, 'Der Eintrag wurde gespeichert.'));
                    this.$state.go('medicamentList');
                });
            }
            /**
             * delete medioaction
             *
             * @private
             *
             * @memberOf MedikamenteDetailController
             */
            deleteMedicament() {
                QMC.Common.Utilities.confirm(this.promptOptions, (data) => {
                    if (data)
                        this.medicamentService.deleteMedicament(this.medicationForm.objectId).then(() => {
                            this.$qui.notify(this.$qui.deleteNote);
                            this.$state.go('medicamentList');
                        });
                });
            }
            /**
             * get PackageTypeList from API
             *
             * @private
             * @returns {ng.IPromise<Common.ISelectListItem[]>}
             *
             * @memberOf MedikamenteDetailController
             */
            getPackageTypeList() {
                return this.medicamentService.getMedicamentPackageWv().then((data) => {
                    return this.ui.select(data.packageUnitWvList, {
                        value: 'objectId',
                        text: 'name'
                    });
                });
            }
            /**
             * get StandardSizeWvList from API
             *
             * @private
             * @returns {ng.IPromise<Common.ISelectListItem[]>}
             *
             * @memberOf MedikamenteDetailController
             */
            getStandardSizeWvList() {
                return this.medicamentService.getMedicamentPackageWv().then((data) => {
                    return this.ui.select(data.standardSizeWvList, {
                        value: "objectId",
                        text: "name"
                    });
                });
            }
            /**
             * get ActiveComponentUnitWvList from API
             *
             * @private
             * @returns {ng.IPromise<Common.ISelectListItem[]>}
             *
             * @memberOf MedikamenteDetailController
             */
            getActiveComponentUnitWvList() {
                return this.medicamentService.getMedicamentPackageWv().then((data) => {
                    return this.ui.select(data.activeComponentUnitWvList, {
                        value: 'objectId',
                        text: 'name'
                    });
                });
            }
            /**
             * get all WV lists
             *
             * @private
             *
             * @memberOf MedikamenteDetailController
             */
            getWvs() {
                this.medicamentService.getMedicamentWv().then((data) => {
                    this.wvLists = data;
                    this.presentationList = this.$qui.selectAutoMap(data.presentationWvList, 'objectId', 'name');
                    this.categoryMap = this.$qui.selectAutoMap(data.categoryWvList, 'objectId', 'name');
                    this.producerMap = this.$qui.selectAutoMap(data.producerWvList, 'objectId', 'name');
                    this.$qui.functionWaiter("ui.createForm", this);
                });
            }
            ////////////////////////// Medi Package //////////////////////////
            /**
             * get Medication Package from API for modification
             *
             * @private
             * @param {IMedicamentPackage} data
             *
             * @memberOf MedikamenteDetailController
             */
            editPackage(data) {
                this.medicamentService.getMedicamentPackage(data.objectId, this.medicamentId).then((data) => {
                    this.formState = "edit";
                    this.packageForm = angular.copy(data);
                    this.packageForm.dateFrom = this.$qui.createDateFromString(data.dateFrom);
                    if (data.dateTo !== null)
                        this.packageForm.dateTo = moment(data.dateTo).toDate();
                });
            }
            /**
             * Post new Medication Package to API
             *
             * @private
             * @param {IMedicamentPackage} form
             *
             * @memberOf MedikamenteDetailController
             */
            postMedicamentPackage(form) {
                if (this.isSetGuid(form.parentId) && this.isSetGuid(form.packageUnitId)) {
                    this.medicamentService.postMedicamentPackage(this.packageForm).then((data) => {
                        this.ui.notify(this.ui.successNote);
                        this.getMedicamentPackages(this.medicamentId);
                        this.formState = "new";
                    });
                }
            }
            /**
             * Put modified Medication Package to API
             *
             * @private
             * @param {IMedicamentPackage} form
             *
             * @memberOf MedikamenteDetailController
             */
            putMedicamentPackage(form) {
                form.parentId = this.medicamentId;
                this.medicamentService.putMedicamentPackage(form.objectId, form).then((data) => {
                    this.ui.notify(this.ui.successNote);
                    this.getMedicamentPackages(this.medicamentId);
                    this.formState = "new";
                });
            }
            /**
             * Deleting Medicament Package
             *
             * @private
             * @param {IMedicamentPackage} data
             *
             * @memberOf MedikamenteDetailController
             */
            deleteMedicamentPackage(datas) {
                $('#medicamentPackageModal').modal('toggle');
                QMC.Common.Utilities.confirm(this.promptOptions, (data) => {
                    if (data)
                        this.medicamentService.deleteMedicamentPackage(datas.objectId, this.medicamentId).then(() => {
                            this.ui.notify(this.ui.deleteNote);
                            this.formState = "new";
                            this.getMedicamentPackages(this.medicamentId);
                        });
                });
            }
        };
        MedikamenteDetailController = __decorate([
            QMC.Controller('QMC.Medikamente', 'MedikamenteDetailController'),
            QMC.Inject('$location', 'MedikamenteService', '$qui', '$stateParams', '$state', '$scope', 'QmcLanguageService', 'QmcPermissionService')
        ], MedikamenteDetailController);
    })(Medikamente = QMC.Medikamente || (QMC.Medikamente = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Medikamente;
    (function (Medikamente) {
        let MedikamenteDistributionController = class MedikamenteDistributionController {
            constructor($location, medicamentService, $qui, $stateParams, $state, $scope, lng, clientService, permissionService, userService) {
                this.$location = $location;
                this.medicamentService = medicamentService;
                this.$qui = $qui;
                this.$state = $state;
                this.$scope = $scope;
                this.lng = lng;
                this.clientService = clientService;
                this.permissionService = permissionService;
                this.userService = userService;
                //////////////////////////// Variables ///////////////////////////
                /************************* GUI Variables ************************/
                this.ui = new Medikamente.UserInterface();
                this.allowTableExport = false;
                this.loadingPlanned = false;
                this.loadingDemand = false;
                this.cards = false;
                this.isMobile = QMC.Common.Constants.IS_MOBILE;
                this.filterStorageKey = 'mediDistributionFilter_';
                this.isDemand = false;
                this.loadValidation = false;
                this.multiValidationWatcher = [];
                this.currentTimepoints = [];
                this.multiEnabled = false;
                // new multiselection
                this.selectedLines = [];
                this.recentlyDistributedPannedMedications = [];
                $qui.init($qui.getSectionColor($location.path()), () => {
                    $qui.anonAvatar();
                    $qui.bindEvents();
                    setTimeout(() => {
                        this.events();
                    }, 500);
                });
                this.isDemand = this.$state.current.name === "medicamentDemandDistribution";
                this.filterStorageKey += this.$state.current.name;
                if (document.getElementById("permissions").getAttribute("medicamentDistribution").toLocaleLowerCase() !== "true") {
                    console.log("No rights to see module medicamentDistribution");
                    this.forbidden = true;
                    return;
                }
                this.cards = false;
                if (QMC.Common.Constants.IS_MOBILE)
                    this.cards = true;
                if (!this.isDemand)
                    this.userService.getUserSettings(["MEDAUSGABE.PA.ALLOWMULTIDOCUMENTATION"], false).then((data) => {
                        this.multiEnabled = data[0].value.toLowerCase() === 'true';
                    });
                this.permissionLoad = true;
                permissionService.getPermissionsByObjectType(800003).then((data) => {
                    this.delete = data[0].delete && data[0].moduleAccess;
                    this.new = data[0].new && data[0].moduleAccess;
                    this.modify = data[0].modify && data[0].moduleAccess;
                    this.view = data[0].view && data[0].moduleAccess;
                    this.allowTableExport = data[0].print;
                    this.init();
                    //Get medications is called here, so we can be sure if the user has the permission to see/get the data.
                    this.$qui.getTableAutoload(this.userService).then((ltd) => {
                        this.shouldLoadTableData = ltd;
                        if (this.shouldLoadTableData) {
                            this.getData();
                        }
                    });
                    this.permissionLoad = false;
                });
                this.$scope.$on('$destroy', () => { if (this.refreshTimer)
                    clearTimeout(this.refreshTimer); });
            }
            getData(silentRefresh = false) {
                clearTimeout(this.refreshTimer);
                if (!this.loadingPlanned || !this.loadingDemand)
                    this.getMedications(silentRefresh);
                // refresh List every 60secs
                if (!this.isDemand)
                    this.refreshTimer = setTimeout(() => { this.getData(true); }, 60000);
            }
            ////////////////////////// DISPLAYLOGIC //////////////////////////
            init() {
                this.initForm();
                this.filterPeriodValue = '2';
                this.onlyUndocumented = false;
                this.onlyUncompleted = false;
                const mediFilterSettings = QMC.Common.personalLocalStorage.getItem(this.filterStorageKey);
                if (mediFilterSettings) {
                    const filterObj = JSON.parse(mediFilterSettings);
                    this.filterPeriodValue = filterObj.filterPeriodValue;
                    this.onlyUndocumented = filterObj.onlyUndocumented;
                    this.onlyUncompleted = filterObj.onlyUncompleted;
                }
                this.setFilter();
            }
            initForm() {
                this.reference = QMC.Common.Constants.GUID_EMPTY;
                this.noReasonError = false;
                this.date = new Date();
                this.time = new Date();
                this.form = {
                    amount: 0,
                    date: new Date(),
                    isDistributed: true,
                    referenceTimeId: QMC.Common.Constants.GUID_EMPTY,
                    reason: ""
                };
            }
            events() {
                this.$scope.$watchGroup(['vm.onlyUndocumented', 'vm.onlyUncompleted', 'vm.filterPeriodValue'], (newValues, oldValues) => {
                    if (JSON.stringify(newValues) !== JSON.stringify(oldValues)) {
                        this.setFilter();
                        this.getMedications();
                    }
                });
                this.validation = {
                    errors: ["Es wurde noch keine Validierung durchgeführt"],
                    warnings: []
                };
                this.$scope.$watch('vm.form.isDistributed', (newVal, oldVal) => {
                    if (oldVal !== newVal) {
                        if (newVal === false) {
                            this.form.amount = 0;
                        }
                    }
                }, true);
                this.$scope.$watch('vm.time', (newVal, oldVal) => {
                    if (oldVal !== newVal) {
                        this.form.date = this.$qui.addTimeToDate(this.date, this.time);
                    }
                }, true);
                this.$scope.$watch('vm.filter.filterDistributionDateFrom', (newVal, oldVal) => {
                    if (oldVal !== newVal) {
                        this.getDistributionsForMedication();
                    }
                }, true);
                this.$scope.$watch('vm.filter.filterDistributionDateTo', (newVal, oldVal) => {
                    if (oldVal !== newVal) {
                        this.getDistributionsForMedication();
                    }
                }, true);
                this.$scope.$watch('vm.date', (newVal, oldVal) => {
                    if (oldVal !== newVal) {
                        this.form.date = this.$qui.addTimeToDate(this.date, this.time);
                    }
                }, true);
                this.$scope.$watch('vm.form', (newVal, oldVal) => {
                    if (oldVal !== newVal) {
                        this.validate();
                    }
                }, true);
                this.$scope.$watch('vm.selectedTimepoint', (newVal, oldVal) => {
                    if (oldVal !== newVal && this.multiEnabled) {
                        for (const item of this.currentTimepoints) {
                            item.isChecked = false;
                        }
                        this.createCurrentTimepoints();
                    }
                }, true);
            }
            createCurrentTimepoints() {
                // kill multi validation watcher
                for (const item of this.multiValidationWatcher) {
                    item();
                }
                // create multi validation watcher
                this.multiValidationWatcher = [];
                this.currentTimepoints = this.timepoints[this.selectedTimepoint];
                if (!this.currentTimepoints || !this.selectedTimepoint)
                    return;
                for (let i = 0; i < this.currentTimepoints.length; i++) {
                    this.multiValidationWatcher.push(this.$scope.$watch(`vm.currentTimepoints[${i}].form`, (newVal, oldVal) => {
                        if (!newVal || newVal === oldVal)
                            return;
                        this.currentTimepoints[i].validation = this.validatePlannedMedication(this.currentTimepoints[i].form, this.currentTimepoints[i]);
                    }, true));
                }
            }
            setFilter() {
                this.filter = {
                    filterDateFrom: this.checkPeriod(this.filterPeriodValue),
                    filterDateTo: new Date(),
                    filterDistributionDateFrom: this.checkPeriod(this.filterPeriodValue),
                    filterDistributionDateTo: new Date(),
                    filterMedicationId: QMC.Common.Constants.GUID_EMPTY,
                    filterMedicationDateFrom: new Date(),
                    filterMedicationDateTo: new Date(),
                };
                const storageOb = {
                    filterPeriodValue: this.filterPeriodValue,
                    onlyUndocumented: this.onlyUndocumented,
                    onlyUncompleted: this.onlyUncompleted
                };
                QMC.Common.personalLocalStorage.setItem(this.filterStorageKey, JSON.stringify(storageOb));
            }
            checkPeriod(filter) {
                let dateFrom;
                switch (filter) {
                    case '1':
                        dateFrom = new Date();
                        break;
                    case '2':
                        dateFrom = moment().startOf('week').toDate();
                        break;
                    case '3':
                        dateFrom = moment().startOf('month').toDate();
                        break;
                    case '4':
                        dateFrom = moment().subtract(30, 'days').toDate();
                        break;
                    default:
                        dateFrom = moment().startOf('week').toDate();
                        break;
                }
                return dateFrom;
            }
            showDistributionsModal(medication) {
                if ((this.filter.filterMedicationId != medication.id) ||
                    (this.filter.filterDistributionDateFrom === this.filter.filterDateFrom && this.filter.filterDistributionDateTo === this.filter.filterDateTo) ||
                    (this.filter.medicationId === null || this.filter.filterDistributionDateFrom === null || this.filter.filterDistributionDateFTo === null)) {
                    this.showDistributions = {
                        objectId: medication.objectId,
                        client: medication.personForename + " " + medication.personName,
                        medicament: medication.medicament,
                        package: medication.medicamentPackage,
                        medicationType: medication.medicationType,
                        amount: medication.amount,
                        amountDistributed: medication.amountDistributed,
                        isDemand: medication.medicationTypeId === QMC.Common.Constants.DEMAND_MEDICATION,
                        distributions: medication.distributions,
                        timepoint: medication.timepoint
                    };
                    this.filter.filterMedicationId = this.isDemand ? medication.id : medication.medicationId;
                    this.filter.filterDistributionDateFrom = this.filter.filterDateFrom;
                    this.filter.filterDistributionDateTo = this.filter.filterDateTo;
                    this.filter.filterMedicationDateFrom = medication.dateFrom;
                    this.filter.filterMedicationDateTo = medication.dateTo;
                }
                else {
                    this.getDistributionsForMedication();
                }
                $('#medicamentDistributionsModal').modal('show');
            }
            newDistributionModal(medication) {
                this.initForm();
                this.showDistributions = {
                    objectId: medication.objectId,
                    client: medication.personForename + " " + medication.personName,
                    medicament: medication.medicament,
                    package: medication.medicamentPackage,
                    medicationType: medication.medicationType,
                    amount: medication.amount,
                    amountDistributed: medication.amountDistributed,
                    isDemand: medication.medicationTypeId === QMC.Common.Constants.DEMAND_MEDICATION,
                    //use the dateFrom to set the start date of the demanded medication, when is a demanded medication user can set the date
                    //also in the past, but not smaller than the medication start date
                    dateFrom: this.$qui.createDateFromString(medication.dateFrom),
                    dateTo: medication.dateTo != null ? this.$qui.createDateFromString(medication.dateTo) : null,
                };
                this.reference = medication.referenceMedication;
                if (this.reference === undefined)
                    this.reference = medication.objectId;
                this.form.amount = medication.amount;
                if (this.$state.current.name === "medicamentPlannedDistribution") {
                    this.form.referenceTimeId = medication.referenceTimeId;
                    this.date = moment(medication.date).toDate();
                    this.time = moment(medication.date).toDate();
                }
                $('#medicamentNewDistributionModal').modal('show');
            }
            getTimeString(input) {
                const date = moment(input).toDate();
                const hours = date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
                const minutes = date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
                return hours + ":" + minutes;
            }
            createTimepointModal() {
                this.lastList = undefined;
                this.selectedTimepoint = undefined;
                this.createMultiTimepoints();
                $('#multi-medication-modal').modal('show');
            }
            createMultiTimepoints() {
                if (!this.multiEnabled)
                    return;
                // if nothing has changed dont update the modal
                if (this.lastList === JSON.stringify(this.ui.plannedMedicationTable.data))
                    return;
                this.lastList = JSON.stringify(this.ui.plannedMedicationTable.data);
                this.timepoints = {};
                this.timepointsMap = [];
                this.currentTimepoints = [];
                this.multiState = "select";
                for (const item of this.plannedDistributions) {
                    if (item.isDistributed)
                        continue;
                    const timepointName = moment(item.date).format('DD.MM.YYYY') + ' ' + item.timepoint;
                    if (!this.timepoints[timepointName])
                        this.timepoints[timepointName] = [];
                    item.form = {
                        amount: item.amount,
                        date: moment(item.date).toDate(),
                        time: moment(item.date).toDate(),
                        isDistributed: true,
                        reason: '',
                        referenceTimeId: item.referenceTimeId
                    };
                    item.validation = { errors: [], warnings: [] };
                    this.timepoints[timepointName].push(item);
                }
                for (const item in this.timepoints) {
                    this.timepointsMap.push({ text: item, value: item, date: this.$qui.createDateFromString(this.timepoints[item][0].date) });
                }
                this.timepointsMap.sort((a, b) => a.date.getTime() - b.date.getTime());
                if (!this.selectedTimepoint || !this.timepointsMap.some(x => x.value === this.selectedTimepoint)) {
                    // preselect timepoint nearest to now
                    const now = new Date().getTime();
                    let minDist;
                    for (const item of this.timepointsMap) {
                        const dist = now - item.date.getTime();
                        if (!minDist || minDist > dist) {
                            this.selectedTimepoint = item.value;
                            minDist = dist;
                        }
                    }
                }
                this.createCurrentTimepoints();
                this.$qui.scopeApply();
            }
            isMultiValid() {
                if (!this.selectedTimepoint || !this.currentTimepoints || this.currentTimepoints.length === 0)
                    return false;
                const activeMedications = this.currentTimepoints.filter(x => x.isChecked);
                if (activeMedications.length === 0 || activeMedications.filter(x => x.validation.errors.length > 0).length > 0)
                    return false;
                return true;
            }
            getMultiMedicationHeaderString() {
                return this.$qui.formatString(this.lng.translate(21009062, 'Folgende Medikamente werden für den Zeitpunkt <strong>{0}</strong> ausgegeben.'), this.selectedTimepoint);
            }
            multiToggle(state) {
                for (const item of this.currentTimepoints) {
                    item.isChecked = state;
                }
            }
            ////////////////////////// SERVICECALLS //////////////////////////
            getMedications(silentRefresh = false) {
                if (this.isDemand)
                    this.getDemandMedications();
                if (!this.isDemand)
                    this.getPlannedMedications(false, !silentRefresh);
            }
            getPlannedMedications(force = false, showLoading = true) {
                var _a;
                const semaphor = { data: JSON.stringify({ dateFrom: moment(this.filter.filterDateFrom).startOf('d'), dateTo: moment(this.filter.filterDateTo).endOf('d'), onlyUncompleted: this.onlyUncompleted, onlyUndocumented: this.onlyUndocumented }), timestamp: new Date() };
                if (!force && ((_a = this.duplicateRequestSemaphor) === null || _a === void 0 ? void 0 : _a.data) === semaphor.data) { // same request as before?
                    const thresholdPassed = Math.abs(this.duplicateRequestSemaphor.timestamp.getTime() - semaphor.timestamp.getTime()) > 1000; // have at least 1s passed?
                    if (!thresholdPassed)
                        return;
                }
                this.duplicateRequestSemaphor = semaphor;
                if (showLoading)
                    this.loadingPlanned = true;
                this.medicamentService.getPlannedMedicationLists(this.filter.filterDateFrom, this.filter.filterDateTo, this.onlyUncompleted, this.onlyUndocumented).then((data) => {
                    data.forEach(item => {
                        item.client = this.createClientDisplayTitle(item);
                        item.distAmount = this.$qui.qmcRounding(item.amountDistributed) + '/' + this.$qui.qmcRounding(item.amount);
                        item.rowKey = this.getPlannedDistributionRowKey(item);
                        item.timepointMobile = `${moment(item.date).format('DD.MM.YYYY')} ${item.timepoint}`;
                        item.isSelected = this.selectedLines.some(x => x === item.rowKey);
                    });
                    this.plannedDistributions = data;
                    this.ui.plannedMedicationTable.data = this.plannedDistributions;
                    this.$qui.functionWaiter("createPlannedTable", this);
                    if (showLoading)
                        this.loadingPlanned = false;
                    this.selectedLines = this.selectedLines.filter(x => data.some(y => y.rowKey === x));
                });
            }
            reloadPlannedDistributions() {
                this.duplicateRequestSemaphor = undefined;
                this.lastList = undefined;
                if (!this.isDemand) {
                    this.getPlannedMedications(true);
                }
            }
            getPlannedDistributionRowKey(item) {
                return item.referenceTimeId + '|' + moment(item.date).format('YYYY-MM-DD') + '|' + item.referenceMedication;
            }
            findPlannedDistribution(match) {
                var _a;
                const data = this.plannedDistributions || ((_a = this.ui.plannedMedicationTable) === null || _a === void 0 ? void 0 : _a.data);
                if (!data)
                    return null;
                if (match.rowKey) {
                    return data.find(x => x.rowKey === match.rowKey || this.getPlannedDistributionRowKey(x) === match.rowKey);
                }
                if (match.referenceTimeId && match.date) {
                    return data.find(x => x.referenceTimeId === match.referenceTimeId
                        && moment(x.date).isSame(match.date, 'day')
                        && (!match.referenceMedication || x.referenceMedication === match.referenceMedication));
                }
                return null;
            }
            notifyNoMedicationsToDistribute() {
                this.$qui.notify({
                    message: this.lng.translate(21009069, 'Es konnten keine Medikationen ausgegeben werden.'),
                    title: this.lng.translate(20000110, 'Warnungen'),
                    icon: 'qm-icon-information',
                    status: 'warning',
                    timer: 3500
                });
            }
            createClientDisplayTitle(item) {
                var _a, _b;
                const persNrShortDescr = (((_a = item.personNr) !== null && _a !== void 0 ? _a : '') + '/' + ((_b = item.personShortCaption) !== null && _b !== void 0 ? _b : '')).replace(/^\/|\/$/g, '');
                return item.personForename + " " + item.personName + (persNrShortDescr ? ` (${persNrShortDescr})` : '');
            }
            getDemandMedications() {
                this.loadingDemand = true;
                this.medicamentService.getDemandMedicationLists(this.filter.filterDateFrom, this.filter.filterDateTo, this.onlyUncompleted, this.onlyUndocumented).then((data) => {
                    this.demandDistributions = data;
                    this.demandDistributions.map(item => {
                        item.client = this.$qui.createPersonDisplay(item.personName, item.personForename, item.personShortCaption, item.personNr);
                    });
                    this.demandDistributions.map((obj, index) => {
                        obj.maxAmountString = obj.maxAmount + ' ' + obj.maxAmountInterval;
                        obj.lastDistributionDateString = obj.lastDistribution && moment(obj.lastDistribution).toDate() >= new Date(1900, 1, 1) ? moment(obj.lastDistribution).format('DD.MM.YYYY') : "";
                    });
                    this.ui.demandMedicationTable.data = this.demandDistributions;
                    this.$qui.functionWaiter("createDemandTable", this);
                    this.loadingDemand = false;
                });
            }
            getDistributionsForMedication() {
                var _a, _b, _c;
                const dateFrom = (_a = this.filter.filterDistributionDateFrom) !== null && _a !== void 0 ? _a : this.filter.filterMedicationDateFrom;
                const dateTo = (_b = this.filter.filterDistributionDateTo) !== null && _b !== void 0 ? _b : this.filter.filterMedicationDateTo;
                if (!((_c = this.filter) === null || _c === void 0 ? void 0 : _c.filterMedicationId) || this.filter.filterMedicationId === QMC.Common.Constants.GUID_EMPTY)
                    return;
                this.medicamentService.getDistributionsForMedication(moment(dateFrom).startOf('day').format(), moment(dateTo).endOf('day').format(), this.filter.filterMedicationId).then((data) => {
                    if (this.showDistributions)
                        this.showDistributions.distributions = data;
                });
            }
            addMedicamentDistribution() {
                this.form.date = this.$qui.addTimeToDate(this.date, this.time);
                if (this.form.reason === "" && !this.form.isDistributed) {
                    this.noReasonError = true;
                }
                else {
                    $('#medicamentNewDistributionModal').modal('hide');
                    $('body').removeClass('modal-open');
                    $('.modal-backdrop').remove();
                    if (this.$scope.form.$valid) {
                        this.medicamentService.postMedication(this.reference, this.form).then((data) => {
                            this.$qui.notify(this.$qui.successNote, this.lng.translate(20000291, 'Der Eintrag wurde gespeichert.'));
                            this.reloadPlannedDistributions();
                        });
                    }
                }
            }
            saveMulti() {
                if (!this.multiEnabled)
                    return;
                this.multiState = 'loading';
                const medications = [];
                for (const item of this.currentTimepoints) {
                    if (item.isChecked && item.validation.errors.length === 0) {
                        medications.push({
                            amount: item.form.amount,
                            date: this.$qui.addTimeToDate(item.form.date, item.form.time),
                            isDistributed: item.form.isDistributed,
                            reason: item.form.reason,
                            referenceTimeId: item.referenceTimeId,
                            medicationId: item.referenceMedication
                        });
                    }
                }
                if (!medications.length) {
                    this.multiState = 'select';
                    this.notifyNoMedicationsToDistribute();
                    return;
                }
                this.medicamentService.postMedications(medications).then(() => {
                    this.$qui.notify(this.$qui.successNote, this.lng.translate(20000291, 'Der Eintrag wurde gespeichert.'));
                }).finally(() => {
                    $('#multi-medication-modal').modal('hide');
                    this.multiState = 'select';
                    this.reloadPlannedDistributions();
                });
            }
            validate() {
                if (this.isDemand && this.form.amount >= 0) {
                    if (!this.form || !this.showDistributions)
                        return;
                    if (!this.form.isDistributed) {
                        this.lastValidation = null;
                        this.validation = {
                            errors: [],
                            warnings: []
                        };
                    }
                    const validationRequest = {
                        medicationId: this.showDistributions.objectId,
                        amount: this.form.amount,
                        date: this.form.date
                    };
                    if (this.lastValidation && JSON.stringify(this.lastValidation) === JSON.stringify(validationRequest))
                        return;
                    this.lastValidation = validationRequest;
                    this.loadValidation = true;
                    setTimeout(() => {
                        if (this.lastValidation && JSON.stringify(this.lastValidation) === JSON.stringify(validationRequest)) {
                            this.medicamentService.postValidation(validationRequest).then((data) => {
                                this.validation = data;
                                this.loadValidation = false;
                            }).catch(() => {
                                this.validation = {
                                    errors: ["Während der Validierung trat ein Fehler auf."],
                                    warnings: []
                                };
                                this.loadValidation = false;
                            });
                        }
                    }, 500);
                }
                else {
                    this.validation = this.validatePlannedMedication(this.form);
                }
            }
            validatePlannedMedication(medicationForm, planningRow) {
                const validation = { errors: [], warnings: [] };
                if (medicationForm.amount > 0) {
                    if (!medicationForm || !this.ui.plannedMedicationTable.data)
                        return validation;
                    const planning = planningRow || this.findPlannedDistribution({
                        referenceTimeId: medicationForm.referenceTimeId,
                        date: medicationForm.date,
                        referenceMedication: this.reference
                    });
                    if (!planning)
                        return validation;
                    const amount = this.$qui.qmcRounding(parseFloat(medicationForm.amount + '') + parseFloat(planning.amountDistributed + ''));
                    const plannedAmount = this.$qui.qmcRounding(parseFloat(planning.amount + ''));
                    if (amount !== plannedAmount) {
                        if (!medicationForm.reason || medicationForm.reason.length < 1) {
                            validation.errors.push(this.lng.translate(21009058, "Die Ausgabemenge ist abweichend. Bitte geben Sie einen Grund an."));
                        }
                        else {
                            validation.warnings.push(this.lng.translate(21009059, "Die Ausgabemenge ist abweichend."));
                        }
                    }
                }
                else if (medicationForm.isDistributed) {
                    validation.errors.push(this.lng.translate(21009063, "Bitte geben Sie eine Menge an."));
                }
                return validation;
            }
            selectLine(status, line) {
                const key = line.rowKey || this.getPlannedDistributionRowKey(line);
                if (status) {
                    if (!this.selectedLines.includes(key))
                        this.selectedLines.push(key);
                }
                else {
                    this.selectedLines = this.selectedLines.filter(x => x !== key);
                }
            }
            distributeSelectedLines() {
                if (!this.selectedLines.length)
                    return;
                this.loadingPlanned = true;
                this.recentlyDistributedPannedMedications = [];
                this.selectedLines.forEach(lineKey => {
                    const planning = this.findPlannedDistribution({ rowKey: lineKey });
                    if (!planning || planning.isDistributed || planning.isDocumented)
                        return;
                    this.recentlyDistributedPannedMedications.push({
                        amount: planning.amount,
                        date: planning.date,
                        isDistributed: true,
                        reason: '',
                        referenceTimeId: planning.referenceTimeId,
                        medicationId: planning.referenceMedication,
                        timepoint: planning.timepoint,
                        client: this.createClientDisplayTitle(planning),
                        medicament: planning.medicament
                    });
                });
                if (!this.recentlyDistributedPannedMedications.length) {
                    this.loadingPlanned = false;
                    this.notifyNoMedicationsToDistribute();
                    return;
                }
                this.medicamentService.postMedications(this.recentlyDistributedPannedMedications).then(() => {
                    this.$qui.notify(this.$qui.successNote, this.recentlyDistributedPannedMedications.length + ' ' + this.lng.translate(21009066, 'Medikationen ausgegeben.'));
                    this.selectedLines = [];
                    $('#recently-distributed-medications-modal').modal('show');
                }).finally(() => {
                    this.reloadPlannedDistributions();
                });
            }
        };
        MedikamenteDistributionController = __decorate([
            QMC.Controller('QMC.Medikamente', 'MedikamenteDistributionController'),
            QMC.Inject('$location', 'MedikamenteService', '$qui', '$stateParams', '$state', '$scope', 'QmcLanguageService', 'KlientService', 'QmcPermissionService', 'UserService')
        ], MedikamenteDistributionController);
    })(Medikamente = QMC.Medikamente || (QMC.Medikamente = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Medikamente;
    (function (Medikamente) {
        /**
         * Stammdaten UserInterface class
         *
         * @export
         * @class UserInterface
         * @extends {Common.UserInterface}
         */
        class UserInterface extends QMC.Common.UserInterface {
            constructor() {
                super(...arguments);
                /**
                 * Medicament table
                 * @memberOf UserInterface
                 */
                this.medicamentTable = {
                    "config": {
                        "defaultSort": "title",
                        "sortReverse": "false",
                    },
                    "table": {
                        "Name": {
                            "label": "title",
                            "dType": "string",
                            "lngTag": "20000072"
                        },
                        "Darreichung": {
                            "label": "presentation",
                            "dType": "string",
                            "lngTag": "21009002"
                        },
                        "Kategorie": {
                            "label": "category",
                            "dType": "string",
                            "lngTag": "20000137"
                        },
                        "Wirkstoff": {
                            "label": "activeComponent",
                            "dType": "string",
                            "lngTag": "21009004"
                        },
                        "Verschreibungspflichtig": {
                            "label": "isPrescriptionNeeded",
                            "dType": "Bool",
                            "lngTag": "21009005"
                        },
                        "Apothekenpflichtig": {
                            "label": "isPharmacyOnly",
                            "dType": "Bool",
                            "lngTag": "21009006"
                        },
                        "Aktionen": {
                            "dType": "Button",
                            "icon": "qm-icon-pencil blue",
                            "href": "#/medicament/{{objectId}}",
                            "tooltip": "Bearbeiten",
                            "lngTag": "20000044",
                            "permission": "modify"
                        },
                    },
                    "card": {
                        "avatar": {
                            "icon": "qm-icon-pill",
                        },
                        "text": {
                            "label": "title",
                            "dType": "string"
                        },
                        "subtext": [
                            {
                                "label": "presentation",
                                "dType": "string"
                            },
                            {
                                "label": "activeComponent",
                                "dType": "string",
                            },
                        ],
                        "buttons": [{
                                "icon": "qm-icon-pencil blue",
                                "href": "#/medicament/{{objectId}}",
                                "label": "data",
                                "dType": "Button",
                                "tooltip": "Medikament bearbeiten",
                                "lngTag": "21009007",
                                "permission": "view",
                            }]
                    },
                    "data": null,
                };
                this.medicamentForm = {
                    form: [
                        {
                            placeholder: "Name",
                            label: "Name",
                            type: "String",
                            lngTag: "20000072",
                            required: "true",
                            model: "title",
                            validate: {
                                message: "Bitte einen Namen eingeben.",
                                messageTag: "20000079",
                            },
                            style: {
                                icon: "qm-icon-check",
                                class: "col-xs-12"
                            },
                        },
                        {
                            placeholder: "Darreichungsform auswählen...",
                            label: "Darreichungsform",
                            type: "Select",
                            lngTag: "21009009",
                            model: "presentationId",
                            required: "true",
                            dataSource: "getPresentationWvList",
                            validate: {
                                message: "Bitte Darreichungsform eintragen."
                            },
                            style: {
                                class: "col-md-6 col-xs-12",
                            },
                        },
                        {
                            placeholder: "Kategorie auswählen...",
                            label: "Kategorie",
                            type: "Select",
                            lngTag: "20000137",
                            model: "categoryId",
                            dataSource: "getCategoryList",
                            style: {
                                class: "col-xs-12 col-md-6"
                            },
                        },
                        {
                            placeholder: "Hersteller auswählen...",
                            label: "Hersteller",
                            type: "Select",
                            lngTag: "21009011",
                            model: "producerId",
                            dataSource: "getProducerWvList",
                            style: {
                                class: "col-xs-12 col-md-6"
                            },
                        },
                        {
                            placeholder: "Hauptwirkstoff",
                            label: "Hauptwirkstoff",
                            type: "String",
                            lngTag: "21009012",
                            model: "activeComponent",
                            style: {
                                icon: "qm-icon-injection",
                                class: "col-xs-12 col-md-6"
                            }
                        },
                        {
                            label: "Zusatz",
                            type: "String",
                            model: "comment",
                            lngTag: "21009016",
                            style: {
                                icon: "qm-icon-note_text",
                                class: "col-xs-12",
                            }
                        },
                        {
                            label: "Apothekenpflichtig",
                            type: "Checkbox",
                            lngTag: "21009006",
                            model: "isPharmacyOnly",
                            id: "modPharmacy",
                            style: {
                                class: "col-xs-6"
                            }
                        },
                        {
                            label: "Verschreibungspflichtig",
                            type: "Checkbox",
                            lngTag: "21009005",
                            model: "isPrescriptionNeeded",
                            id: "modPrescrip",
                            style: {
                                class: "col-xs-6"
                            }
                        },
                        {
                            label: "Zugangsbeschränkt",
                            type: "Checkbox",
                            lngTag: "21009013",
                            model: "isRestricted",
                            id: "modRestrict",
                            style: {
                                class: "col-xs-6"
                            }
                        },
                        {
                            label: "Betäubungsmittel",
                            type: "Checkbox",
                            lngTag: "21009014",
                            model: "isAnesthetic",
                            id: "modAnesthetic",
                            style: {
                                class: "col-xs-6"
                            }
                        }
                    ],
                    actions: {
                        post: "addMedicament"
                    }
                };
                this.mediPackagesTable = {
                    "config": {
                        "showTitle": "true",
                        "defaultSort": "displayTitle",
                        "sortReverse": "false",
                    },
                    "table": {
                        "Menge": {
                            "label": "packageAmount",
                            "dType": "Number",
                            "lngTag": "20000095"
                        },
                        "Einheit": {
                            "label": "packageUnit",
                            "dType": "string",
                            "lngTag": "20000096"
                        },
                        "Normgröße": {
                            "label": "standardsize",
                            "dType": "string",
                            "lngTag": "20000097"
                        },
                        "Gültigkeit": {
                            "label": "dateFrom",
                            "dType": "Date",
                            "lngTag": "20000098"
                        },
                        "Aktionen": [{
                                "icon": "qm-icon-pencil blue",
                                "click": "editPackage",
                                "label": "data",
                                "dType": "Button",
                                "tooltip": "Bearbeiten",
                                "openModal": "true",
                                "targetModal": "#medicamentPackageModal",
                                "lngTag": "20000044",
                                "permission": "pmodify"
                            }]
                    },
                    "card": {
                        "avatar": {
                            "icon": "qm-icon-pill"
                        },
                        "text": {
                            "label": "displayTitle",
                            "dType": "string"
                        },
                        "subtext": [
                            {
                                "label": ["packageAmount", "packageUnit"],
                                "dType": "string"
                            },
                        ],
                        "buttons": {
                            "icon": "qm-icon-pencil blue",
                            "click": "editPackage",
                            "label": "data",
                            "dType": "Button",
                            "tooltip": "Bearbeiten",
                            "openModal": "true",
                            "targetModal": "#medicamentPackageModal",
                            "lngTag": "20000044",
                        }
                    },
                    "data": null,
                };
                this.mediPackagesForm = {
                    form: [
                        {
                            lngTag: {
                                dateFrom: "20000277",
                                dateTo: "20000278"
                            },
                            label: {
                                dateFrom: "Gültig von",
                                dateTo: "Gültig bis"
                            },
                            type: "DateRange",
                            model: {
                                dateFrom: "dateFrom",
                                dateTo: "dateTo"
                            },
                            style: {
                                class: "col-xs-12"
                            },
                            config: {
                                displayDateTo: true
                            }
                        },
                        {
                            label: "Menge",
                            type: "Number",
                            lngTag: "20000095",
                            model: "packageAmount",
                            maxLength: 10,
                            style: {
                                icon: "qm-icon-symbol_hash",
                                class: "col-md-3 col-xs-6 no-mobile-padding-left",
                            }
                        },
                        {
                            placeholder: "Darreichungsform auswählen ...",
                            label: "Darreichungsform",
                            type: "Select",
                            lngTag: "21009009",
                            model: "packageUnitId",
                            required: true,
                            dataSource: "getPackageTypeList",
                            validate: {
                                message: "Bitte auswählen",
                                messageTag: "20000099",
                            },
                            style: {
                                class: "col-md-9 col-xs-6 no-mobile-padding-right"
                            },
                        },
                        {
                            label: "Normgröße",
                            type: "Select",
                            lngTag: "20000097",
                            model: "standardSizeId",
                            dataSource: "getStandardSizeWvList",
                            style: {
                                class: "col-xs-12"
                            },
                        },
                        {
                            placeholder: "PZN",
                            placeholderTag: "20000092",
                            label: "PZN",
                            type: "String",
                            lngTag: "20000092",
                            model: "pzn",
                            style: {
                                icon: "fa fa-barcode",
                                class: "col-md-6 col-xs-12"
                            },
                        },
                        {
                            placeholder: "EAN",
                            placeholderTag: "20000093",
                            label: "EAN",
                            type: "String",
                            lngTag: "20000093",
                            model: "ean",
                            style: {
                                icon: "fa fa-barcode",
                                class: "col-md-6 col-xs-12"
                            },
                        },
                        {
                            placeholder: "Wirkstoffmenge",
                            placeholderTag: "21009056",
                            label: "Wirkstoffmenge",
                            type: "Number",
                            lngTag: "21009056",
                            model: "activeComponentAmount",
                            maxLength: 10,
                            style: {
                                icon: "qm-icon-symbol_hash",
                                class: "col-md-9 col-xs-6 no-mobile-padding-left"
                            }
                        },
                        {
                            label: "Einheit",
                            type: "Select",
                            model: "activeComponentUnitId",
                            dataSource: "getActiveComponentUnitWvList",
                            lngTag: "20000096",
                            style: {
                                class: "col-md-3 col-xs-6 no-mobile-padding-right"
                            },
                        },
                        {
                            placeholder: "Bemerkung",
                            placeholderTag: "20000049",
                            label: "Bemerkung",
                            type: "Textarea",
                            maxLength: 255,
                            lngTag: "20000049",
                            model: "comment",
                            style: {
                                icon: "qm-icon-note_text",
                                class: "col-xs-12",
                            }
                        }
                    ],
                    actions: {
                        post: "postMedicamentPackage",
                        put: "putMedicamentPackage",
                        delete: "deleteMedicamentPackage"
                    }
                };
                this.plannedMedicationTable = {
                    "config": {
                        "defaultSort": "date",
                        "sortReverse": "false",
                    },
                    "table": {
                        "": {
                            "id": "rowKey",
                            "selected": "isSelected",
                            "dType": "Checkbox",
                            "events": {
                                "onChange": "selectLine"
                            },
                            "hide": "isDocumented"
                        },
                        "Datum": {
                            "label": "date",
                            "dType": "Date",
                            "lngTag": "20000045"
                        },
                        "Zeitpunkt": {
                            "label": "timepoint",
                            "dType": "string",
                            "lngTag": "21009027"
                        },
                        "Medikament": {
                            "label": "medicament",
                            "dType": "string",
                            "lngTag": "21009028"
                        },
                        "Klient": {
                            "label": "client",
                            "dType": "string",
                            "lngTag": "21002000"
                        },
                        "Menge": {
                            "label": "distAmount",
                            "dType": "string",
                            "lngTag": "20000095"
                        },
                        "Ausgabe dokumentiert": {
                            "label": "isDocumented",
                            "dType": "Bool",
                            "lngTag": "21009039"
                        },
                        "Aktionen": [{
                                "icon": "qm-icon-eye blue",
                                "click": "showDistributionsModal",
                                "tooltip": "Ausgaben betrachten",
                                "lngTag": "21009040",
                                "dType": "Button",
                                "targetModal": "#medicamentDistributionsModal",
                                "permission": "modify"
                            }, {
                                "icon": "qm-icon-pill green",
                                "click": "newDistributionModal",
                                "tooltip": "Medikament ausgeben",
                                "lngTag": "21009041",
                                "dType": "Button",
                                "events": {
                                    "hide": "isDistributed"
                                },
                                "targetModal": "#medicamentNewDistributionModal",
                                "permission": "new"
                            }],
                    }
                    // Mobile Card View
                    ,
                    "card": {
                        "avatar": {
                            "icon": "qm-icon-pill"
                        },
                        "text": {
                            "label": "medicament",
                            "dType": "string"
                        },
                        "subtext": [
                            {
                                "label": "client",
                                "dType": "string"
                            },
                            {
                                "label": "timepointMobile",
                                "dType": "string",
                            },
                            {
                                "label": "isDocumented",
                                "text": "Ist ausgegeben",
                                "lngTag": "21009033",
                                "dType": "Bool",
                            },
                            {
                                "label": "isDocumented",
                                "text": "Ausgabe dokumentiert",
                                "lngTag": "21009039",
                                "dType": "Bool",
                            },
                        ],
                        "buttons": [
                            {
                                "icon": "qm-icon-eye blue",
                                "click": "showDistributionsModal",
                                "tooltip": "Ausgaben betrachten",
                                "lngTag": "21009040",
                                "dType": "Button",
                                "targetModal": "#medicamentDistributionsModal",
                                "permission": "modify"
                            },
                            {
                                "icon": "qm-icon-pill green",
                                "click": "newDistributionModal",
                                "tooltip": "Medikament ausgeben",
                                "lngTag": "21009041",
                                "dType": "Button",
                                "hide": "isDistributed",
                                "targetModal": "#medicamentNewDistributionModal",
                                "permission": "new",
                                "events": {
                                    "hide": "isDistributed"
                                },
                            }
                        ]
                    },
                    "data": null,
                };
                this.demandMedicationTable = {
                    "table": {
                        "Medikament": {
                            "label": "medicament",
                            "dType": "string",
                            "lngTag": "21009028"
                        },
                        "Klient": {
                            "label": "client",
                            "dType": "string",
                            "lngTag": "21002000"
                        },
                        "Letzte Ausgabe": {
                            "label": "lastDistributionDateString",
                            "dType": "Date",
                            "lngTag": "21009044"
                        },
                        "Packung": {
                            "label": "medicamentPackage",
                            "dType": "string",
                            "lngTag": "21009029"
                        },
                        "Max. Menge": {
                            "label": "maxAmountString",
                            "dType": "string",
                            "lngTag": "21009045"
                        },
                        "Aktionen": [
                            {
                                "icon": "qm-icon-eye blue",
                                "click": "showDistributionsModal",
                                "tooltip": "Ausgaben betrachten",
                                "lngTag": "21009040",
                                "dType": "Button",
                                "targetModal": "#medicamentDistributionsModal",
                                "permission": "modify"
                            },
                            {
                                "icon": "qm-icon-pill green",
                                "click": "newDistributionModal",
                                "tooltip": "Medikament ausgeben",
                                "lngTag": "21009041",
                                "dType": "Button",
                                "events": {
                                    "hide": "isDistributed"
                                },
                                "targetModal": "#medicamentNewDistributionModal",
                                "permission": "new"
                            }
                        ],
                    }
                    // Mobile Card View
                    ,
                    "card": {
                        "avatar": {
                            "icon": "qm-icon-pill"
                        },
                        "text": {
                            "label": "medicament",
                            "dType": "string"
                        },
                        "subtext": [
                            {
                                "label": "medicamentPackage",
                                "dType": "string"
                            },
                            {
                                "label": "client",
                                "dType": "string"
                            },
                        ],
                        "buttons": [
                            {
                                "icon": "qm-icon-eye blue",
                                "click": "showDistributionsModal",
                                "tooltip": "Ausgaben betrachten",
                                "lngTag": "21009040",
                                "dType": "Button",
                                "targetModal": "#medicamentDistributionsModal",
                                "permission": "modify"
                            },
                            {
                                "icon": "qm-icon-pill green",
                                "click": "newDistributionModal",
                                "tooltip": "Medikament ausgeben",
                                "lngTag": "21009041",
                                "dType": "Button",
                                "hide": "isDistributed",
                                "targetModal": "#medicamentNewDistributionModal",
                                "permission": "new"
                            }
                        ]
                    },
                    "data": null,
                };
            }
        }
        Medikamente.UserInterface = UserInterface;
    })(Medikamente = QMC.Medikamente || (QMC.Medikamente = {}));
})(QMC || (QMC = {}));

//# sourceMappingURL=../../maps/Medikamente/qmc.medikamente.js.map
